import {Component} from 'react';
import PropTypes from 'prop-types';

const INITIAL_STATE = {
  closesAt: 0,
  isOpen: false,
  willClose: false,
};

export default class DelayedClose extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeDelayMs: PropTypes.number,
  };
  static defaultProps = {
    closeDelayMs: 200,
  };

  state = INITIAL_STATE;

  componentDidMount() {
    if (this.props.isOpen) {
      this.open();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.open();
    } else if (prevProps.isOpen && !this.props.isOpen) {
      this.close();
    }
  }

  closeTimer = null;

  open = () => {
    if (this.state.willClose) {
      if (this.closeTimer !== null) {
        clearTimeout(this.closeTimer);
      }
      this.setState({willClose: false});
    } else {
      this.setState({isOpen: true});
    }
  };

  close = () => {
    if (this.props.closeDelayMs > 0) {
      this.closeWithTimeout();
    } else {
      this.closeWithoutTimeout();
    }
  };

  closeWithTimeout = () => {
    const closesAt = Date.now() + this.props.closeDelayMs;
    this.setState({willClose: true, closesAt}, () => {
      this.closeTimer = setTimeout(
        this.closeWithoutTimeout,
        // compensate for any time it takes for the above setState to
        // "flush" i.e. re-render so timeout lasts for only exactly `this.props.closeDelayMs`
        this.state.closesAt - Date.now()
      );
    });
  };

  closeWithoutTimeout = () => this.setState(INITIAL_STATE);

  render() {
    return this.props.children({
      isOpen: this.state.isOpen,
      willClose: this.state.willClose || !this.state.isOpen,
    });
  }
}
